.backdrop {
  position: fixed;
  inset: 0;
  z-index: 50;

  display: flex;
  align-items: flex-start;
  justify-content: center;

  padding: var(--space-xl) var(--space-m);

  background-color: rgb(4 12 14 / 68%);

  overflow-y: auto;
}

.card {
  display: flex;
  flex-direction: column;

  width: 100%;
  max-width: 34rem;

  background-color: var(--surface-raised);

  border: 1px solid var(--border-strong);
  border-radius: var(--radius-m);
  box-shadow: var(--shadow-raised);
}

.wide {
  max-width: 52rem;
}

/* Focus lands on the card when it opens; the card itself needs no ring for that. */
.card:focus {
  outline: none;
}

.card:focus-visible {
  box-shadow: var(--shadow-raised), var(--ring);
}

.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-m);

  padding: var(--space-m) var(--space-l);

  border-block-end: 1px solid var(--border);
}

.headline {
  display: flex;
  flex-direction: column;
  gap: var(--space-3xs);
}

.title {
  font-size: var(--size-400);
}

.description {
  font-family: var(--font-mono);
  font-size: var(--size-100);

  color: var(--text-faint);

  overflow-wrap: anywhere;
}

.body {
  padding: var(--space-l);
}
